const ProgressBar = ({
  displayProgress,
  disableTransition,
}: ProgressBarProps) => {
  return (
    <>
      <div
        className="progress-container__filter"
        style={{
          width: `${displayProgress}%`,
          transition: disableTransition ? 'none' : undefined,
        }}
      />
      <div className="progress-container__percentage">
        {`${Math.round(displayProgress)}%`}
      </div>
    </>
  );
};

export default ProgressBar;

export type ProgressBarProps = {
  displayProgress: number;
  disableTransition?: boolean;
};
